<div
  class="search-container w-auto d-flex justify-content-center align-items-center"
>
  <input
    (keyup)="sendSearch()"
    type="text"
    placeholder="search remark"
    [(ngModel)]="search"
    class="rounded"
  />
</div>
